import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { PushMessage, PushMessagesResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class PushMessagesDataService {

  private uri: string = `${environment.apiUrl}push-messages`;
  private cacheKey: string = 'pushMessages.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getPushMessage(id: number): Observable<PushMessage|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getPushMessages(parameters: {[param: string]: string | string[]}): Observable<PushMessagesResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addPushMessage(data: PushMessage): Observable<PushMessage|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addPushMessages(data: PushMessage[]): Observable<PushMessage[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updatePushMessage(data: PushMessage): Observable<PushMessage|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updatePushMessages(data: PushMessage[]): Observable<PushMessage[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchPushMessage(data: PushMessage): Observable<PushMessage|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchPushMessages(data: PushMessage[]): Observable<PushMessage[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deletePushMessage(data: PushMessage): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deletePushMessages(data: PushMessage[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((pushMessage) => {
      ids.push(pushMessage.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
